// @generated by protoc-gen-es v2.14.1 with parameter "target=ts"
// @generated from file travplaces/v1/audit.proto (package travplaces.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenExtension, GenFile } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, extDesc, fileDesc } from "@bufbuild/protobuf/codegenv2";
import type { MethodOptions } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_descriptor } from "@bufbuild/protobuf/wkt";

/**
 * Describes the file travplaces/v1/audit.proto.
 */
export const file_travplaces_v1_audit: GenFile = /*@__PURE__*/
  fileDesc("Chl0cmF2cGxhY2VzL3YxL2F1ZGl0LnByb3RvEg10cmF2cGxhY2VzLnYxKmwKCkF1ZGl0TGV2ZWwSGwoXQVVESVRfTEVWRUxfVU5TUEVDSUZJRUQQABIUChBBVURJVF9MRVZFTF9OT05FEAESFAoQQVVESVRfTEVWRUxfSU5GTxACEhUKEUFVRElUX0xFVkVMX0VSUk9SEAM6XAoLYXVkaXRfbGV2ZWwSHi5nb29nbGUucHJvdG9idWYuTWV0aG9kT3B0aW9ucxiijQYgASgOMhkudHJhdnBsYWNlcy52MS5BdWRpdExldmVsUgphdWRpdExldmVsOkkKD29iZnVzY2F0ZV9maWVsZBIeLmdvb2dsZS5wcm90b2J1Zi5NZXRob2RPcHRpb25zGKONBiADKAlSDm9iZnVzY2F0ZUZpZWxkQqUBChFjb20udHJhdnBsYWNlcy52MUIKQXVkaXRQcm90b1ABWi90cmF2cGxhY2VzL2dlbi9wcm90by90cmF2cGxhY2VzL3YxO3RyYXZwbGFjZXN2MaICA1RYWKoCDVRyYXZwbGFjZXMuVjHKAg1UcmF2cGxhY2VzXFYx4gIZVHJhdnBsYWNlc1xWMVxHUEJNZXRhZGF0YeoCDlRyYXZwbGFjZXM6OlYxYgZwcm90bzM", [file_google_protobuf_descriptor]);

/**
 * AuditLevel says when a call to a method is written to the audit log.
 *
 * @generated from enum travplaces.v1.AuditLevel
 */
export enum AuditLevel {
  /**
   * Not a choice anyone makes. It is what the absence of the option looks
   * like, which is how the startup sweep tells "nobody decided" apart from
   * "somebody decided no".
   *
   * @generated from enum value: AUDIT_LEVEL_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Deliberately not audited. Reads, overwhelmingly: the catalogue is served
   * to every console page load and recording that it was looked at would bury
   * the writes without answering any question anyone asks.
   *
   * @generated from enum value: AUDIT_LEVEL_NONE = 1;
   */
  NONE = 1,

  /**
   * Audited whether it succeeds or fails. The right level for anything that
   * changes state — the failed attempt is as interesting as the successful
   * one, and often more so.
   *
   * @generated from enum value: AUDIT_LEVEL_INFO = 2;
   */
  INFO = 2,

  /**
   * Audited only when the call returns an error. For methods where the
   * successful case is high-volume and unremarkable but a failure is worth
   * keeping.
   *
   * @generated from enum value: AUDIT_LEVEL_ERROR = 3;
   */
  ERROR = 3,
}

/**
 * Describes the enum travplaces.v1.AuditLevel.
 */
export const AuditLevelSchema: GenEnum<AuditLevel> = /*@__PURE__*/
  enumDesc(file_travplaces_v1_audit, 0);

/**
 * When calls to this method are recorded. Required: a method that declares
 * no level cannot be served, and the server names it at boot and exits.
 *
 * Field numbers here are extension numbers on descriptor.proto. They have to
 * be unique among extensions of MethodOptions, which is why this starts at
 * 100002 — 100001 is required_permissions in authz.proto. The numbers on
 * EnumValueOptions in that file are a separate space and do not collide.
 *
 * @generated from extension: travplaces.v1.AuditLevel audit_level = 100002;
 */
export const audit_level: GenExtension<MethodOptions, AuditLevel> = /*@__PURE__*/
  extDesc(file_travplaces_v1_audit, 0);

/**
 * Fields of the request to replace with a mask before the request is
 * recorded. A password reaches the server in the clear by necessity; it has
 * no business surviving in a table that is, by design, impossible to delete
 * a row from.
 *
 * Named in proto spelling (snake_case), matching the field as declared, and
 * top-level only — a secret nested inside a sub-message is not covered. Put
 * secrets at the top level of the request, or extend the redaction.
 *
 * @generated from extension: repeated string obfuscate_field = 100003;
 */
export const obfuscate_field: GenExtension<MethodOptions, string[]> = /*@__PURE__*/
  extDesc(file_travplaces_v1_audit, 1);

